// EmdgFooterNav.tsx

import React, { ReactNode } from 'react'

interface EmdgFooterNavProps {
    children: ReactNode;
    className?: string;
    ariaLabel?: string;
    attributeOptions?: React.HTMLAttributes<HTMLDivElement>;
}

const EmdgFooterNav: React.FC<EmdgFooterNavProps> = ({
  children, className = '', ariaLabel = 'footer', attributeOptions = {},
}) => (
  <nav className={`emdg-footer__navigation ${className}`} aria-label={ariaLabel} {...attributeOptions}>
    {children}
  </nav>
)

export default EmdgFooterNav
